<script setup lang="ts">
/**
 * §H — inline "Этот запрос: ₽X" badge. Shows the cost (in kopecks) of a single
 * AI request to ANY role (no gate) — the per-request transparency that pairs
 * with the admin AI-cost ledger. Renders nothing when the cost is unknown.
 *
 * Theme-safe: uses surface/accent CSS-var classes that adapt to light & dark
 * (no fixed Tailwind light palette).
 */
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { formatKopecks } from "../../utils/number-format";

const props = defineProps<{
  /** This request's cost in kopecks. null/undefined → badge hidden. */
  kopecks: number | null | undefined;
}>();

const { t } = useI18n();
const visible = computed(() => props.kopecks != null && Number.isFinite(props.kopecks));
</script>

<template>
  <span
    v-if="visible"
    class="inline-flex items-center gap-1 rounded-full border border-surface-200 bg-surface-100 px-2 py-0.5 text-xs font-medium text-surface-600"
    :title="t('ai.cost.tooltip')"
  >
    <svg class="h-3 w-3 opacity-70" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM8 6h2.2a2.3 2.3 0 010 4.6H9.2V12H11v1.2H9.2V14H8v-.8H6.8V12H8v-1.4H6.8V9.4H8V6zm1.2 1.2v2.2h1a1.1 1.1 0 000-2.2h-1z" />
    </svg>
    {{ t('ai.cost.this_request') }}: {{ formatKopecks(kopecks) }}
  </span>
</template>
